import { STEP_TYPES } from './constants';

export function convertStepsToEditorFormat(visitStep, goalSteps) {
  const result = [];
  if (visitStep) {
    result.push({ type: STEP_TYPES.VISIT });
  }
  goalSteps.forEach((g) => result.push({ type: STEP_TYPES.GOAL, id: g.id }));

  return result;
}

export function convertGoalStepsToDBFormat(steps) {
  return steps.filter((s) => s.type === STEP_TYPES.GOAL).map((s) => s.id);
}
